import React from 'react';
import PropTypes from 'prop-types';
import { Link, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
var NotFound = function NotFound(_ref) {
  var message = _ref.message,
    isRoute = _ref.isRoute;
  var location = useLocation();
  return React.createElement('div', {
    className: 'text-center'
  }, React.createElement(FontAwesomeIcon, {
    icon: 'info-circle',
    size: '3x',
    className: 'mb-3'
  }), React.createElement('h6', null, isRoute && location.pathname + ' ', 'Not Found'), message && React.createElement('p', null, message), isRoute && React.createElement(Link, {
    to: '/home'
  }, 'go home'));
};
NotFound.propTypes = {
  message: PropTypes.string,
  isRoute: PropTypes.bool
};
NotFound.defaultProps = {
  message: undefined,
  isRoute: false
};
export default NotFound;